<template>
  <div class="full">
    <GLArtCanvas class="h-full w-full rounded-lg" :rounded="'8px 8px 8px 8px'">
      <Bloomer :settings="{
        exposure: 1.0,
        bloomStrength: 1.0,
        bloomThreshold: 20.72 / 100.0,
        bloomRadius: 100.99 / 100.0 * 1
      }"></Bloomer>

      <!-- <O3D :scale="{ x: 0.6, y: 0.6, z: 0.6 }">
        <GLFlower></GLFlower>
      </O3D>
      <O3D :py="80" :scale="{ x: 0.3, y: 0.3, z: 0.3 }">
        <GLFlower></GLFlower>
      </O3D>

      <O3D :py="-80" :scale="{ x: 0.3, y: 0.3, z: 0.3 }">
        <GLFlower></GLFlower>
      </O3D> -->

      <!-- <EnergyArt :pz="50" :lowres="true"></EnergyArt> -->
      <FastFlame :sx="1.5" :sy="1.0" :sz="1.0" :pz="0" :lowres="false"></FastFlame>
    </GLArtCanvas>
  </div>
</template>

<script>
import { O3DNode } from '../../Core/O3DNode'
export default {
  mixins: [
    O3DNode
  ]
}
</script>

<style>
</style>
